import { render, staticRenderFns } from "./DetailViewGroupFields.vue?vue&type=template&id=e47dd972&scoped=true"
import script from "./DetailViewGroupFields.vue?vue&type=script&lang=js"
export * from "./DetailViewGroupFields.vue?vue&type=script&lang=js"
import style0 from "./DetailViewGroupFields.vue?vue&type=style&index=0&id=e47dd972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47dd972",
  null
  
)

export default component.exports